import { useTranslation } from 'react-i18next'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { ProcessorDetails } from '@/lib/api/processors'

interface AdyenDescriptorCardProps {
    processor: ProcessorDetails
}

export const AdyenDescriptorCard = ({ processor }: AdyenDescriptorCardProps) => {
    const { t } = useTranslation('processors')
    const options = processor.options as Record<string, any> | null
    const descriptor = (options?.descriptor as { descriptor?: string } | undefined)?.descriptor

    if (!descriptor) return null

    return (
        <Card className="mb-6">
            <CardHeader>
                <CardTitle>{t('statementDescriptor')}</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="space-y-4">
                    <div>
                        <p className="text-sm text-muted-foreground">{t('descriptor')}</p>
                        <p className="font-semibold">{descriptor}</p>
                    </div>
                    <div className="rounded-lg bg-blue-50 p-3 border border-blue-200">
                        <p className="text-sm text-blue-700">
                            <strong>{t('note')}:</strong> This text appears on your customer's bank statement.
                        </p>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}
